import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { TARA_ERROR_LOGS_API } from '../../constants/central-api';

export default async function post_tara_error_log_api_call(errorLogs: any) {
  const shopSlug = store.getState().user?.company?.shop_slug;
  const accessToken = store.getState().auth.authorization.accessToken;
  const isWhiteLabel = store.getState().UI?.isWhiteLabel;
  let sellerToken: string;
  if (isWhiteLabel) {
    sellerToken = accessToken?.currentWhiteLabelSellerToken;
  } else {
    sellerToken = accessToken?.sellerToken;
  }

  const formData: any = new FormData();
  formData.append(`event`, 'error');
  formData.append('shop_slug', shopSlug);
  formData.append('message', JSON.stringify(errorLogs));

  const requestInfo: RequestInfo = {
    url: TARA_ERROR_LOGS_API,
    method: 'POST',
    body: formData,
    headers: {
      Accept: 'application/json',
      // 'Content-type': 'application/x-www-form-urlencoded',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'POST_TARA_ERROR_LOGS';
  const customMsg = 'Error logs posted successfully';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );

  const response = res?.data;

  if (res?.actionType === actionType && response?.success === true) {
    console.log('Tara Error Log API call successful:', response);
  } else {
    console.log('Tara Error Log API call failed:', response);
  }
}
